import React from 'react';
import { Grid, Typography, createStyles, makeStyles, useTheme } from '@material-ui/core';
import { useTranslation } from '@michelin/central-provider';
import { rgbToRgba } from 'utils/format';

const useStyles = makeStyles(() =>
  createStyles({
    selector: {
      height: 70,
      border: '1px solid  rgba(26,26,26,1)',
      textAlign: 'center',
      alignItems: 'center',
      cursor: 'pointer',
      position: 'relative',
      marginLeft: -1,
    },
    lineThrough: {
      height: 70,
      border: '1px solid',
      textAlign: 'center',
      alignItems: 'center',
      position: 'relative',
      marginLeft: -1,
      opacity: 0.4,
      // eslint-disable-next-line max-len
      background:
        'linear-gradient(to top left, rgba(0,0,0,0) 0%, rgba(0,0,0,0) calc(50% - 0.8px), rgba(0,0,0,1) 50%, rgba(0,0,0,0) calc(50% + 0.8px), rgba(0,0,0,0) 100%)',
    },
  }),
);

interface OptionSelectorProps {
  optionA: string;
  optionB: string;
  price: string;
  selected: boolean;
  disabledA: boolean;
  disabledB: boolean;
  onSelect: (option: boolean) => void;
}

export function OptionSelector(props: OptionSelectorProps) {
  const { t } = useTranslation();
  const theme = useTheme();
  const classes = useStyles();

  const { optionA, optionB, selected, onSelect, price, disabledA, disabledB } = props;
  const backgroundColor = rgbToRgba(theme.palette.primary.main, 0.2);
  return (
    <Grid container spacing={0} style={{ marginTop: 8, marginBottom: 16 }}>
      <Grid
        direction="row"
        alignItems="flex-end"
        justify="center"
        item
        container
        xs={6}
        onClick={disabledA ? undefined : () => onSelect(false)}
        className={disabledA ? classes.lineThrough : classes.selector}
        style={{
          background: !disabledA && !selected ? backgroundColor : undefined,
          color: !disabledA && !selected ? theme.palette.primary.contrastText : theme.palette.text.primary,
        }}
      >
        <div style={{ position: 'absolute' }}>
          <Typography style={{ fontWeight: 'bold' }}>{t(optionA)}</Typography>
        </div>
      </Grid>
      <Grid
        direction="row"
        alignItems="flex-end"
        justify="center"
        item
        container
        xs={6}
        onClick={disabledB ? undefined : () => onSelect(true)}
        className={disabledB ? classes.lineThrough : classes.selector}
        style={{
          background: !disabledB && selected ? backgroundColor : undefined,
          color: !disabledB && selected ? theme.palette.primary.contrastText : theme.palette.text.primary,
        }}
      >
        <div style={{ position: 'absolute' }}>
          <Typography style={{ fontWeight: 'bold' }}>{t(optionB)}</Typography>
          {price && <Typography>{t(`+ ${price}`)}</Typography>}
        </div>
      </Grid>
    </Grid>
  );
}
